import React, { FC } from 'react'
import Cookie from 'js-cookie'
import { useTranslation } from 'react-i18next'
import { styled } from '@creditas/stylitas'
import { Typography } from '@creditas/typography'

import { ProfileTypes } from 'types/enums'
import { ToastrContainer } from 'components/Toastr'
import { NextClientButton } from './NextClient'

type Props = {
  profileType: ProfileTypes
}

const Wrapper = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 64px;
`

const cookieKey = 'triage-count-team-leader'

export const Heading: FC<Props> = ({ profileType }) => {
  const count = Number(Cookie.get(cookieKey)) || 0
  const { t } = useTranslation(['formalization'])

  return (
    <>
      <Wrapper>
        <div>
          <Typography variant="h4">{t('heading.title')}</Typography>
          {profileType === ProfileTypes.TeamLeader && (
            <Typography variant="paragraph">
              {count > 0
                ? t(`heading.counter-team-leader`, { count })
                : t(`heading.counter-team-leader_zero`)}
            </Typography>
          )}
        </div>
        <NextClientButton profileType={profileType} />
      </Wrapper>
      <ToastrContainer />
    </>
  )
}
